<template>
  <v-container fluid class="text-xs-center" style="margin-top: 10%">
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Sign In</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <v-form ref="form" @submit.prevent="userSignIn">
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <div class="alert alert-danger" role="alert" v-if="errorMessage">
              {{ errorMessage }}
            </div>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                :rules="emailRules"
                prepend-icon="mail"
                autocomplete="on"
                required
              >
              </v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                v-model="password"
                prepend-icon="vpn_key"
                autocomplete="on"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                :rules="passwordRules"
                required
              ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-4>
              <v-btn color="primary" type="submit"> Sign In</v-btn>
            </v-flex>
            <v-flex class="text-xs-center" mt-4>
              <!--v-btn  type="submit" @click="googleSignIn" >
                <a href="#" class="google btn">
                  <i class="fab fa-google fa-fw"></i> Login with Google
                </a>
              </v-btn-->
              <button type="button" class="google-btn" @click="googleSignIn">
                <div class="google-icon-wrapper" >
                  <img
                    class="google-icon"
                    src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
                  />
                </div>
                <p class="btn-text"><b>Sign in with google</b></p>
              </button>
            </v-flex>
            <!--v-flex class="text-xs-center" mt-4>
              <v-btn  type="submit" @click="fbSignIn" >
                <a href="#" class="facebook btn">
                  <i class="fab fa-facebook fa-fw"></i> Login with Facebook
                </a>
              </v-btn>
            </v-flex-->
            <v-flex class="text-xs-center" mt-3>
              <p>
                Don't have an account yet?
                <router-link to="/signup">Sign Up</router-link>
              </p>
              <router-link to="/forgot">Forgot your password?</router-link>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <!-- <v-container style="margin-top:1%" class="text-xs-center">
        <v-layout row flex wrap justify-space-between>
          <v-flex xs12>
            <v-btn @click="show = !show" flat dark color="success"> Contact Us </v-btn>
          </v-flex>
          <v-flex xs12 class="mt-5">
            <v-tooltip v-model="show" top>
              <v-btn slot="activator" icon>
                <v-icon color="grey lighten-1">email</v-icon>
              </v-btn>
              <span>amir.baradaran@columbia.edu</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container> -->
    </v-layout>
  </v-container>
</template>

<script>
import firebase from "firebase";
import { db } from "../firebaseDB";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
      alert: false,
      errorMessage: "",
      show: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          v.substring(v.indexOf("@")) === "@amirbaradaran.com" ||
          "Please sign in with your company account",
      ],
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 6 || "Password should be at least 6 characters",
      ],
    };
  },

  methods: {
    userSignIn() {
      db.ref(`users`)
        .once("value")
        .then((snapshot) => {
          let emails = [];
          let _this = this;
          let authUser = {};
          Object.keys(snapshot.val()).forEach((k) => {
            emails.push(snapshot.val()[k].email);
            if (_this.email == snapshot.val()[k].email) {
              authUser = snapshot.val()[k];
            }
          });

          if (!emails.includes(this.email)) {
            this.errorMessage =
              "There is no user record corresponding to this identifier. The user may have been deleted.";
          } else if (authUser.status == false) {
            this.errorMessage =
              "your account is suspended. Please contact the Admin";
          } else if (this.$refs.form.validate()) {
            this.$store.dispatch("userSignIn", {
              email: this.email,
              password: this.password,
            });
          }
        });
    },
    toRoute(rname, rparams = {}, query = {}) {
      this.$router.push({ name: rname, params: rparams, query: query });
    },
    googleSignIn() {
      this.$store.dispatch("userGoogleSignIn");
    },
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    },
  },
};
</script>

<style lang="scss" >
a {
  text-decoration: none;
}
.google-btn {
  width: 184px;
  height: 42px;
  background-color: #4285f4;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  .google-icon-wrapper {
    position: absolute;
    margin-top: -8px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: #fff;
  }
  .google-icon {
    margin-top: 8px;
  }
  .btn-text {
    float: right;
    margin: 3px 11px 0 0;
    color: #fff;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px #4285f4;
  }
  &:active {
    background: #1669F2;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Signin.vue